<template>
  <div class="container_main">

    <el-menu router class="el-menu-vertical-demo" :default-active="current_index" @open="handleOpen"
             @close="handleClose" :collapse="isCollapse">
      <div class="style_style_top">
        通讯管理系统
      </div>

      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-postcard"></i>
          <span slot="title" class="style_text_menu">公共资料</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="personmanager">
            <i class="el-icon-setting"></i>
            <span slot="title" class="style_text_menu">人员管理</span>
          </el-menu-item>
          <el-menu-item index="visitor" v-if="userName == 'admin'">
            <i class="el-icon-setting"></i>
            <span slot="title" class="style_text_menu">访客管理</span>
          </el-menu-item>

          <el-menu-item index="department">
            <i class="el-icon-setting"></i>
            <span slot="title" class="style_text_menu">部门管理</span>
          </el-menu-item>

          <el-menu-item index="administrator" v-if="userName == 'admin'">
            <i class="el-icon-setting"></i>
            <span slot="title" class="style_text_menu">分管理员管理</span>
          </el-menu-item>

        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-document-checked"></i>
          <span slot="title" class="style_text_menu">个人资料</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="personal">
            <i class="el-icon-user"></i>
            <span slot="title" class="style_text_menu">密码设置</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>


    </el-menu>
    <div class="container_right">
      <div class="container_top">

        <el-button type="text" v-model="isCollapse" @click="handleClick">
          <div class="style_fold_btn">
            <i v-if="isCollapse" class="el-icon-s-unfold"/>
            <i v-else class="el-icon-s-fold"/>
          </div>
        </el-button>

        <div v-model="name_menu" class="style_above">
          {{ name_menu }}
        </div>




        <div>





          <el-tooltip class="item" effect="dark" content="退出" placement="bottom-end">
            <el-button type="text" v-model="isCollapse" @click="quit">
              <div class="style_fold_btn">
                <i class="el-icon-switch-button"/>
              </div>
            </el-button>
          </el-tooltip>


        </div>



      </div>
      <div>
        <el-main>
          <router-view/>
        </el-main>
      </div>
    </div>
  </div>
</template>


<script>

export default {
  created() {
    this.current_index = this.$router.currentRoute.name
    this.name_menu = this.$router.currentRoute.meta.title

    this.screenWidth = window.innerWidth
    window.addEventListener('resize',this.handleSize,false)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleSize);
  },
  data() {
    return {
      isCollapse: false,
      userName:localStorage.getItem('CurrentUser'),
      name_menu: '',
      current_index: '',
      // screenLeft:true,
      screenWidth: '',
      screenLeft:true,

    };
  },

  watch: {
    screenWidth: {
      handler: function (val, oldVal) {
        this.screenLeft=val > 800
        if (!this.screenLeft){
          this.isCollapse=true
        }
      }
    },
    $route: {
      handler: function (val, oldVal) {
        this.current_index = val.name
        this.name_menu = val.meta.title
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    handleSize(){
      this.screenWidth = window.innerWidth
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClick() {
      this.isCollapse = !this.isCollapse
    },
    quit() {
      this.$router.push('/login');
    },
    handleJump() {

    },
    setting(){
      this.$router.push('/manager/personal');
    }
  }
}
</script>


<style>
.container_main {
  display: flex;
}

.container_right {
  width: 100%;
  height: 100%;
}

.container_top {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding-right: 10px;
}

.style_style_top {
  font-size: 20px;
  text-align: center;
  margin: 20px;
  color: #409EFF;
  display: flex;
  align-items: center;
}

.style_above {
  font-size: 20px;
}

.style_fold_btn {
  margin: 0 20px;
  font-size: 20px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.container_radio_group {
  margin-bottom: 20px;
}

.style_text_menu {
  font-size: 18px;
  /*color: #001528;*/
}

.style_text_menu:active {
  /*color: #409EFF  !important;*/
}

.el-menu-item {
  /*background-color: rgba(0, 0, 0, 0.1);*/
}

.el-menu-item.is-active {
  background-color: #247bb4 !important;
  color: white !important;
}

.el-menu-item:hover {
  background-color: #247bb4 !important;
  color: white !important;
}

</style>
